// @flow
import * as React from 'react'
import { SocialButtons } from '../../../shared/buttons'
import { useRouter } from 'next/router'

export const FACEBOOK_TEXT = Object.freeze({
  login: 'Login',
  continue: 'Continue',
  signIn: 'Sign in'
})
export type FacebookTextType = $Values<typeof FACEBOOK_TEXT>

export type PropsType = {
  type: FacebookTextType,
  disable: boolean,
  isOutlineStyle: boolean,
  socialAuthAgeCheck: (callback: (params?: any) => Promise<void>) => void,
  isSignUp: boolean
}
export type DispatchPropsType = {
  signInWithFacebook: () => void
}

export default function FacebookSignIn (props: PropsType & DispatchPropsType): React.Node {
  const router = useRouter()
  return (
    <SocialButtons
      onClick={(): void => {
        props.socialAuthAgeCheck(async (): Promise<void> => {
          await router.push({
            query: {
              ...router.query,
              socialAuth: 1,
              method: props.isSignUp ? 'signup' : 'signin'
            }
          })
          props.signInWithFacebook()
        })
      }}
      disable={props.disable}
      isOutlineStyle={props.isOutlineStyle}
    >
      <img
        width={18}
        height={18}
        style={{ marginRight: '8px' }}
        alt="Login with Facebook"
        src={'/images/facebook-icon2x.png'}
      />
      {props.type} with Facebook
    </SocialButtons>
  )
}
